var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.02891 0 0 4.02891 0 9C0 13.9711 4.02891 18 9 18C13.9711 18 18 13.9711 18 9C18 4.02891 13.9711 0 9 0ZM9 4.5C9.62121 4.5 10.125 5.00379 10.125 5.625C10.125 6.24621 9.62121 6.75 9 6.75C8.37879 6.75 7.875 6.24727 7.875 5.625C7.875 5.00273 8.37773 4.5 9 4.5ZM10.4062 13.5H7.59375C7.12969 13.5 6.75 13.1238 6.75 12.6562C6.75 12.1887 7.12793 11.8125 7.59375 11.8125H8.15625V9.5625H7.875C7.40918 9.5625 7.03125 9.18457 7.03125 8.71875C7.03125 8.25293 7.41094 7.875 7.875 7.875H9C9.46582 7.875 9.84375 8.25293 9.84375 8.71875V11.8125H10.4062C10.8721 11.8125 11.25 12.1904 11.25 12.6562C11.25 13.1221 10.8738 13.5 10.4062 13.5Z",
    fill: "#611DED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.ef438f61cd16379ffbf9eaa593d7cef2.svg";
export { ForwardRef as ReactComponent };